__turbopack_context__.v({
  "command": "InstallCommand-module__A5G6fG__command",
  "copy": "InstallCommand-module__A5G6fG__copy",
  "field": "InstallCommand-module__A5G6fG__field",
});
